import {computed, ref} from 'vue'

export type ToastVariant = 'default' | 'destructive'

export interface ToastData {
  id: string
  title?: string
  description?: string
  duration?: number
  variant: ToastVariant
}

const toasts = ref<ToastData[]>([])
let nextToastId = 0

function dismiss(id: string): void {
  toasts.value = toasts.value.filter((item) => item.id !== id)
}

function createToast(data: Omit<ToastData, 'id' | 'variant'> & {variant?: ToastVariant}): string {
  const id = `toast-${nextToastId++}`
  toasts.value = [...toasts.value.slice(-2), {id, variant: 'default', ...data}]
  return id
}

export function useToast() {
  return {
    toasts: computed(() => toasts.value),
    toast: createToast,
    dismiss,
  }
}

export {createToast as toast, dismiss}
